// Catalogues (products / work-sources / payment-modes) API fetchers — Wave E.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type {
  CreateReferenceItemInput,
  ReferenceItem,
  ReferenceListResponse,
  UpdateReferenceItemInput,
} from '../types/api';

export type CatalogueKind = 'products' | 'workSources' | 'paymentModes';

interface CatalogueRoutes {
  list: string;
  create: string;
  update: (id: number) => string;
  delete: (id: number) => string;
}

const ROUTES: Record<CatalogueKind, CatalogueRoutes> = {
  products: {
    list: endpoints.products.list,
    create: endpoints.products.create,
    update: endpoints.products.update,
    delete: endpoints.products.delete,
  },
  workSources: {
    list: endpoints.workSources.list,
    create: endpoints.workSources.create,
    update: endpoints.workSources.update,
    delete: endpoints.workSources.delete,
  },
  paymentModes: {
    list: endpoints.paymentModes.list,
    create: endpoints.paymentModes.create,
    update: endpoints.paymentModes.update,
    delete: endpoints.paymentModes.delete,
  },
};

export async function listCatalogue(kind: CatalogueKind): Promise<ReferenceItem[]> {
  const res = await apiClient.get<ReferenceListResponse>(ROUTES[kind].list);
  return res.data.items;
}

export async function createCatalogueItem(
  kind: CatalogueKind,
  input: CreateReferenceItemInput,
): Promise<ReferenceItem> {
  const res = await apiClient.post<ReferenceItem, CreateReferenceItemInput>(
    ROUTES[kind].create,
    input,
  );
  return res.data;
}

export async function updateCatalogueItem(
  kind: CatalogueKind,
  id: number,
  input: UpdateReferenceItemInput,
): Promise<ReferenceItem> {
  const res = await apiClient.patch<ReferenceItem, UpdateReferenceItemInput>(
    ROUTES[kind].update(id),
    input,
  );
  return res.data;
}

export async function deleteCatalogueItem(
  kind: CatalogueKind,
  id: number,
): Promise<void> {
  await apiClient.delete(ROUTES[kind].delete(id));
}
